import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { genBillPdfApiModel } from 'src/app/core/models/about-court-fee/about-court-fees';
import { FileModel } from 'src/app/core/models/shared/file.model';
import { AboutCourtFeesService } from 'src/app/core/services/about-court-fees/about-court-frees.service';
import { ViewSDKClient } from 'src/app/core/services/viewSDKClient.service';

@Component({
  selector: 'app-payment-bill-fee',
  templateUrl: './payment-bill-fee.component.html',
  styleUrls: ['./payment-bill-fee.component.scss']
})
export class PaymentBillFeeComponent implements OnInit {


  
  caseId:number =0
  billId:number =0
  fileUrl:genBillPdfApiModel = new genBillPdfApiModel
  isAppeal: number = 0
  constructor(
    private route:ActivatedRoute,
    private viewSDKClient: ViewSDKClient,
    private aboutCourtFeesService:AboutCourtFeesService

  ) {
    this.route.params.subscribe((params: any) => {
      console.log('parms:',params)
      this.caseId = params.caseId
      this.billId = params.billId
      this.isAppeal = params.isAppeal

    })
   }

  ngOnInit(): void {
    this.getData()
  }

  async getData() {
    this.fileUrl = await this.aboutCourtFeesService.genBillPdf(this.caseId,this.billId,this.isAppeal);
    // this.renderPDf()
    }

  renderPDf() {
    this.viewSDKClient.ready().then(() => {
      /* Invoke file preview */
      const canvas: any = document.querySelector('#pdf-div');
      canvas.style.display = "block";
      canvas.style.height = "100vh";
      let defConfg = {
        showAnnotationTools: false, 
        showPageControls: true, 
        showDownloadPDF: true, 
        showPrintPDF: true

      }
      this.viewSDKClient.previewFile('pdf-div', defConfg,this.fileUrl.url,'');
    });
  }

}
